export const common = {
  // Navigation
  'nav.features': '機能',
  'nav.howItWorks': '仕組み',
  'nav.pricing': '料金プラン',
  'nav.faq': 'よくある質問',
  'nav.aboutUs': '会社概要',
  'nav.getStarted': '始める',

  // About Us Section
  'aboutUs.badge': "私たちについて",
  'aboutUs.title': "IdeaVerdictが存在する理由",
  'aboutUs.line1': "アイデアは誰にでもある。",
  'aboutUs.line2': "自分のアイデアが通用しないと認める者は少ない。",
  'aboutUs.paragraph1':
    "ほとんどのアイデアは、創業者の勇気不足で失敗するのではない。誰も早い段階で真実を告げなかったから失敗する。IdeaVerdictはその穴を埋める ― 友人が口にしない厳しい現実を、私たちが告げる。",
  'aboutUs.belief1a': "誇張は扱わない。",
  'aboutUs.belief1b': "市場のシグナルだけを扱う。",
  'aboutUs.belief2a': "モチベーションは売らない。",
  'aboutUs.belief2b': "需要、競合、実現可能性に対する明確な読みを売る。",
  'aboutUs.mission1': "私たちの仕事は、あなたのアイデアを良く見せることではない。",
  'aboutUs.mission2': "それが本当に良いかどうかを告げることだ。",
  'aboutUs.analysis':
    "IdeaVerdictは本質的な指標でアイデアを評価する ― 市場構造、実需要、競合、必要資本、収益化までの時間、スケーラビリティ。感情なし。楽観なし。分析のみ。",
  'aboutUs.failure1': "ほとんどの事業は失敗する。",
  'aboutUs.failure2': "裏にいる人間が無能だったからではなく ―",
  'aboutUs.failure3': "誰も、十分早く、十分強く反論しなかったから失敗する。",
  'aboutUs.clarity': "私たちは反論するために存在する。",
  'aboutUs.value1': "直接的。",
  'aboutUs.value2': "正直。",
  'aboutUs.value3': "迅速。",
  'aboutUs.confirm': "アイデアに実体があれば、後押しする。",
  'aboutUs.deny': "なければ、面と向かってそう告げる。",
  'aboutUs.noApplause': "拍手なし。",
  'aboutUs.noSugarcoating': "甘い言葉なし。",
  'aboutUs.noTheater': "芝居なし。",
  'aboutUs.noHype': "判決だけ。",
  // Hero Section
  'hero.badge': '60秒以内のAI判定',
  'hero.title1': 'チェックする前に',
  'hero.title2': '作らないで。',
  'hero.subtitle': 'IdeaVerdictは、懐疑的なVCのようにあなたのアイデアを試験します。',
  'hero.subtitleLine2': '数秒で正直な判定 — 誇大広告も、お世辞もなし。',
  'hero.cta': '判定を受ける',
  'hero.ctaSecondary': '使い方を見る',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'リクエストあたりのクレジット',
  'hero.stat2Value': '7+',
  'hero.stat2Label': '評価次元',
  'hero.stat3Value': '100%',
  'hero.stat3Label': '正直でプライベート',

  // Features Section
  'features.title1': '真実を',
  'features.title2': '求める起業家',
  'features.title3': 'のために',
  'features.bullet1.title': '数秒で正直な判定',
  'features.bullet1.description':
    '強・中・弱 — 各評価の根拠付き。拍手なし、ごまかしなし、芝居なし。',
  'features.bullet2.title': '本当に重要なことで評価',
  'features.bullet2.description':
    'あなたのアイデアは、実需、競合、必要資本、収益化までの時間、スケーラビリティで採点されます — 雰囲気ではありません。',
  'features.bullet3.title': '判定から開発へ',
  'features.bullet3.description':
    'Builder モードは、ゴーサインの出たアイデアを開発者向けブリーフィングに変換します。ユーザーフロー、コア機能、技術メモ。',

  // How It Works
  'howItWorks.title': '仕組み',
  'howItWorks.subtitle': 'ビジネスニッチを明確にする4つのステップ。',
  'howItWorks.step1Title': 'プランを選択',
  'howItWorks.step1Desc': 'スターター、プロ、ビルダーからレビューの深さに応じて選択。',
  'howItWorks.step2Title': 'AIに質問',
  'howItWorks.step2Desc': 'ニッチについて質問してください。各リクエストは30クレジットです。',
  'howItWorks.step3Title': '正直な評価を得る',
  'howItWorks.step3Desc': 'AIが評価：良い、普通、悪い。ごまかしはありません。',
  'howItWorks.step4Title': '決断する',
  'howItWorks.step4Desc': 'これで前に進む価値があるかどうかがわかります。',

  // Pricing
  'pricing.title': '料金プラン',
  'pricing.subtitle': 'レビューの深さに合ったプランを選んでください。',
  'pricing.monthly': '月額',
  'pricing.yearly': '年額',
  'pricing.yearlyDiscount': '年間契約：',
  'pricing.yearlyDiscountValue': '20%割引',
  'pricing.perMonth': '/月',
  'pricing.selectPlan': 'プランを選択',
  'pricing.mostPopular': '最も人気',
  'pricing.footer':
    'すべての価格はCHFです。クレジットは成功したAIレスポンスに対してのみ差し引かれます。',

  
  // Pricing Features
  'pricing.feature1': '無料チャット（フォームなし）',
  'pricing.feature2': '市場ロジックと正直な評価',
  'pricing.feature3': '永続的なチャット履歴',
  'pricing.feature4': '複数の並行チャットセッション',
  'pricing.feature5': '完全多言語対応',
  'pricing.feature6': 'クレジットベースの利用',
  'pricing.feature7': '月次リセット',
  'pricing.feature8': '市場分析',
  'pricing.feature9': '概要',
  'pricing.feature10': '強み',
  'pricing.feature11': '弱み',
  'pricing.feature12': '機会',
  'pricing.feature13': 'リスク',
  'pricing.feature14': '推奨事項',
  'pricing.feature15': 'PDFダウンロード',
  'pricing.feature16': '開発者向けブリーフィングなし',
  'pricing.feature17': 'ビルダーモード: 開発者向けブリーフィング',
  'pricing.feature18': '構造化された概要',

  // Starter Plan
  'pricing.starter.name': 'スターター',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'AIニッチチャットボットへのアクセス',
  'pricing.starter.credits': '月2,500クレジット',
  'pricing.starter.feature1': 'ニッチアイデアの生成',
  'pricing.starter.feature2': 'ニッチの改善',
  'pricing.starter.feature3': '市場の現実チェック',
  'pricing.starter.feature4': '競合評価',
  'pricing.starter.feature5': '時間評価',
  'pricing.starter.feature6': '正直な評価',
  'pricing.starter.feature7': 'プライベートセッション',
  'pricing.starter.feature8': '履歴とエクスポート',

  // Pro Plan
  'pricing.pro.name': 'プロ',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'AIニッチチャットボットへのアクセス',
  'pricing.pro.credits': '月5,000クレジット',
  'pricing.pro.feature1': 'スターターの全機能',
  'pricing.pro.feature2': '集中的なレビューのための追加クレジット',
  'pricing.pro.feature3': '改善提案',
  'pricing.pro.feature4': '代替ニッチ',
  'pricing.pro.feature5': '詳細な市場分析',
  'pricing.pro.feature6': '優先サポート',
  'pricing.pro.feature7': '高度なフィルター',
  'pricing.pro.feature8': 'セッションお気に入り',

  // Builder Plan
  'pricing.builder.name': "ビルダー",
  'pricing.builder.price': '199',
  'pricing.builder.description': "全機能 + ビルダーモード",
  'pricing.builder.credits': "月 10,000 クレジット",
  'pricing.builder.feature1': 'プロの全機能',
  'pricing.builder.feature2': '無制限のAIリクエスト',
  'pricing.builder.feature3': 'ビルダーモード：開発者向けブリーフィング',
  'pricing.builder.feature4': '構造化されたプロジェクト概要',
  'pricing.builder.feature5': 'ユーザーフローとコア機能',
  'pricing.builder.feature6': '技術ノート',
  'pricing.builder.feature7': '非目標の定義',
  'pricing.builder.feature8': 'フェアユースレート制限',
  'pricing.builder.limitNote': 'フェアユース制限',
  'pricing.monthlyReset': '毎月リセット',

  // Modal
  'pricing.modal.selected': '選択中',
  'pricing.modal.comingSoon':
    '登録とお支払い処理はまもなく利用可能になります。',
  'pricing.modal.patience':
    '安全でシームレスな体験を提供できるよう取り組んでいます。今しばらくお待ちください。',
  'pricing.modal.understood': '了解しました',

  // FAQ
  'faq.title': 'よくある質問',
  'faq.subtitle': '正直かつ批判的に回答します。',
  'faq.q1': "IdeaVerdictは実際に何をする?",
  'faq.a1': "結果を左右する要素 ― 実需要、競合、必要資本、市場投入までの時間、スケーラビリティ ― でアイデアを評価する。\nアイデアが通用するなら、磨き方を示す。\n通用しないなら、そう告げる。",
  'faq.q2': "アイデアの生成もする?",
  'faq.a2': "する ― ただし帽子から無作為に取り出すような提案はしない。\nアイデアは今週流行っているものではなく、実在する市場のギャップから生まれる。",
  'faq.q3': "既存のビジネスモデルも改善する?",
  'faq.a3': "改善の余地があるなら、する。\n壊れたアイデアを磨くことはしない ― すでに基盤があるものを強化するだけだ。",
  'faq.q4': "他のAIツールとの違いは?",
  'faq.a4': "ほとんどのAIツールは「あなたのアイデアは素晴らしい」と告げる。\n私たちは「実際にそうなのか」を告げる。\n違いは、熱狂ではなく現実主義。",
  'faq.q5': "成功を保証する?",
  'faq.a5': "しない。\n悪い賭けを避ける手助けはする ― リスクは消えないが、目を見開いて踏み込める。",
  'faq.q6': "IdeaVerdictは誰のためのもの?",
  'faq.a6': "ローンチ前の創業者。\n週末プロジェクトを始める前のビルダー。\n次の賭けに出る前のオペレーター。\n署名する前の投資家。\n\nコミットする前に明晰さが欲しい全員のため。",
  'faq.q7': "承認だけが欲しい場合は?",
  'faq.a7': "それならIdeaVerdictは間違った道具だ。\n私たちは正直な読みを提供する、安心ではない。",
  'faq.q8': "分析は本当にどこまで正直?",
  'faq.a8': "データが許す限り正直。\n感情を傷つけないために弱い判決を和らげることはしない。",
  'faq.q9': "本格的な市場調査の代わりになる?",
  'faq.a9': "ならない。\n投資前の素早い戦略チェックであって、50ページの市場調査ではない。",
  'faq.q10': "なぜそんなに直接的?",
  'faq.a10': "間違ったものを作れば数か月を失うから。\n正直な判決は数分しかかからない。\n\n私たちは数分を選ぶ。",
  // Footer
  'footer.description':
    'IdeaVerdictはあなたを気持ちよくするためのものではありません。正しい決断を下すためのものです。',
  'footer.product': 'プロダクト',
  'footer.aiAssistant': 'AIアシスタント',
  'footer.howItWorks': '仕組み',
  'footer.pricing': '料金プラン',
  'footer.faq': 'よくある質問',
  'footer.legal': '法的情報',
  'footer.privacy': 'プライバシーポリシー',
  'footer.terms': '利用規約',
  'footer.imprint': 'インプリント',
  'footer.support': 'サポート',
  'footer.contact': 'お問い合わせ',
  'footer.documentation': 'ドキュメント',
  'footer.copyright': '© 2026 IdeaVerdict. All rights reserved.',

  // AI Assistant
  'aiAssistant.title': 'AIニッチアシスタント',
  'aiAssistant.subtitle': 'ニッチについて質問する',
  'aiAssistant.welcomeMessage':
    'こんにちは！あなたのアイデアを説明するか、ニッチについて質問してください。明確で正直な評価をします。',
  'aiAssistant.demoResponse':
    'これはデモです。実際のAI評価を受けるには、登録してプランを選択してください。',
  'aiAssistant.placeholder': 'アイデアを説明してください...',

  // Header & Sidebar
  'dashboard.header.title': 'ダッシュボード',
  'dashboard.header.aiAssistant': 'あなたのAIアシスタント',
  'header.logout': 'ログアウト',
  'dashboard.sidebar.overview': '概要',
  'dashboard.sidebar.aiChat': 'AIアシスタント',
  'dashboard.sidebar.newAnalysis': 'AIアシスタント',
  'dashboard.sidebar.history': '履歴',
  'dashboard.sidebar.credits': 'クレジット',
  'dashboard.sidebar.settings': '設定',

  // Dashboard Overview
  'dashboard.overview.welcome': 'おかえりなさい、{{name}}さん',
  'dashboard.overview.subtitle':
    'あなたのアクティビティのクイック概要',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': '残りクレジット',
  'dashboard.stats.totalAnalyses': '総分析数',
  'dashboard.stats.goodRatings': '肯定的評価',
  'dashboard.stats.nextReset': '次のリセットまで',
  'dashboard.stats.days': '日',

  // Quick Actions
  'dashboard.quickActions.title': 'クイックアクション',
  'dashboard.quickActions.checkNewIdea': 'アイデアをチェック',
  'dashboard.quickActions.checkNewIdeaDesc':
    '既存のビジネスアイデアを分析',
  'dashboard.quickActions.generateIdea': 'アイデアを生成',
  'dashboard.quickActions.generateIdeaDesc':
    '新しい収益性の高いニッチを見つける',
  'dashboard.quickActions.builderBriefing': 'ビルダーブリーフィング',
  'dashboard.quickActions.builderBriefingDesc':
    'アイデアを開発者向けブリーフィングに変換',
  'dashboard.quickActions.premiumOnly': 'ビルダーのみ',

  // Chat Header
  'chat.title': 'AIニッチアシスタント',
  'chat.subtitle':
    'ニッチについて質問してください。批判的かつ正直に評価します。',
  'chat.creditsLabel': 'クレジット',

  // Chat Welcome
  'chat.welcomeTitle': 'AIニッチアシスタントへようこそ',
  'chat.welcomeDesc':
    'アイデアを説明するか、ニッチについて質問してください。正直に評価します：良い、普通、悪い。',
  'chat.aiWelcome':
    'こんにちは！あなたのアイデアを説明するか、ニッチについて質問してください。明確で正直な評価をします。',

  // Chat Suggestions
  'chat.suggestion1': 'フリーランサー向けの請求書管理SaaSツールを作りたいです。良いニッチですか？',
  'chat.suggestion2': 'プログラミング不要で$500で始められる競争の少ないオンラインビジネスを見つけて。',
  'chat.suggestion3': 'これを評価して：食事制限のある忙しい親向けのAI食事プランニングアプリ。',
  'chat.suggestion4': 'Etsyで小規模事業者向けのデジタルテンプレートを販売したい。このニッチを正直に分析して。',

  // Chat Actions
  'chat.newConversation': '新しい会話',
  'chat.today': '今日',
  'chat.yesterday': '昨日',
  'chat.thisWeek': '今週',
  'chat.thisMonth': '今月',
  'chat.older': '過去',
  'chat.messages': '件のメッセージ',
  'chat.renameConversation': '名前を変更',
  'chat.deleteConversation': '削除',
  'chat.cancel': 'キャンセル',
  'chat.rename': '名前を変更',
  'chat.delete': '削除',
  'chat.favorite': 'お気に入りに追加',
  'chat.unfavorite': 'お気に入りから削除',
  'chat.searchSessions': '会話を検索...',
  'chat.noResults': '結果が見つかりません',
  'chat.noSessions': 'まだ会話がありません',
  'chat.enterNewName': '新しい名前を入力...',
  'chat.deleteConfirmMessage':
    'この会話を削除してもよろしいですか？この操作は元に戻せません。',

  // Chat Input & Errors
  'chat.inputPlaceholder': '質問を入力してください… (30クレジット消費)',
  'chat.send': '送信',
  'chat.voice': '音声入力',
  'chat.listeningPlaceholder': '聞いています... 今すぐ話してください。',
  'chat.stopListening': '聞き取り停止',
  'chat.recording': '録音中...',
  'chat.speechNotSupported': 'お使いのブラウザは音声認識をサポートしていません。',
  'chat.microphonePermissionDenied': 'マイクアクセスが拒否されました。ブラウザ設定でアクセスを許可してください。',
  'chat.errorNotEnoughCredits':
    'クレジットが不足しています。プランをアップグレードするか、次のリセットまでお待ちください。',
  'chat.errorAiFailed': 'AIレスポンスに失敗しました。クレジットは差し引かれませんでした。',
  'chat.errorRateLimit': 'リクエストが多すぎます。しばらくお待ちください。',

  // Ratings
  'rating.good': '良い',
  'rating.medium': '普通',
  'rating.bad': '悪い',

  // Auth Page
  'auth.branding.headline1': 'すべてのアイデアが良いわけではありません。',
  'auth.branding.headline2': '私たちは正直に伝えます。',
  'auth.branding.subtitle':
    'ビジネスニッチのための意思決定AI。明確。批判的。ごまかしなし。',
  'auth.benefits.privacy.title': '100%プライベート',
  'auth.benefits.privacy.desc':
    'あなたのアイデアは完全にプライベートかつ安全に保たれます。',
  'auth.benefits.honest.title': '正直なAI',
  'auth.benefits.honest.desc':
    'ごまかしなし – 明確で批判的なフィードバック。',
  'auth.benefits.fast.title': '高速な結果',
  'auth.benefits.fast.desc': '数分でニッチについての明確さを得られます。',
  'auth.trust.users': 'アクティブユーザー',
  'auth.trust.ideas': '分析されたアイデア',
  'auth.trust.rating': 'ユーザー評価',
  'auth.login.title': 'ログイン',
  'auth.login.headline': 'おかえりなさい',
  'auth.login.subtitle': '続けるにはサインインしてください。',
  'auth.login.forgotPassword': 'パスワードをお忘れですか？',
  'auth.login.submit': 'サインイン',
  'auth.login.noAccount': 'まだアカウントはありませんか？',
  'auth.login.signUp': 'サインアップ',
  'auth.register.title': '登録',
  'auth.register.headline': 'アカウントを作成',
  'auth.register.subtitle':
    '今日からビジネスアイデアの分析を始めましょう。',
  'auth.register.submit': 'アカウント作成',
  'auth.register.hasAccount': 'すでにアカウントをお持ちですか？',
  'auth.register.signIn': 'サインイン',
  'auth.fields.name': '氏名',
  'auth.fields.email': 'メールアドレス',
  'auth.fields.password': 'パスワード',
  'auth.fields.confirmPassword': 'パスワード確認',
  'auth.fields.selectPlan': 'プランを選択',
  'auth.fields.testCode': 'ログインして無料テスト',
  'auth.placeholders.name': '氏名を入力',
  'auth.placeholders.email': 'メールアドレスを入力',
  'auth.placeholders.password': 'パスワードを入力',
  'auth.placeholders.confirmPassword': 'パスワードを確認',
  'auth.placeholders.testCode': 'テストコードを入力',
  'auth.terms.accept': '次に同意します',
  'auth.terms.terms': '利用規約',
  'auth.privacy.accept': '次に同意します',
  'auth.privacy.policy': 'プライバシーポリシー',
  'auth.errors.nameRequired': '氏名は必須です',
  'auth.errors.emailRequired': 'メールアドレスは必須です',
  'auth.errors.emailInvalid': '有効なメールアドレスを入力してください',
  'auth.errors.passwordRequired': 'パスワードは必須です',
  'auth.errors.passwordLength': 'パスワードは8文字以上である必要があります',
  'auth.errors.passwordMismatch': 'パスワードが一致しません',
  'auth.errors.invalidCode': '無効または期限切れのコードです',
  'auth.errors.registrationCodeOnly': 'このコードは登録のみに使用できます',
  'auth.errors.verificationFailed': 'コード検証エラー。もう一度お試しください。',
  'auth.loading': 'しばらくお待ちください...',
  'auth.or': 'または続ける',
  'auth.social.google': 'Googleで続ける',
  'auth.social.apple': 'Appleで続ける',
  'auth.actions.verify': '検証',
  'auth.testCode.activated': 'テストコードが有効になりました！',
  'auth.testCode.days': '日間',
  'auth.testCode.months': 'ヶ月間',
  'auth.testCode.freeAccess': '無料アクセス',
  'auth.testCode.credits': 'クレジット',

  // Email Verification
  'auth.verification.title': 'メール認証',
  'auth.verification.headline': '受信トレイを確認してください',
  'auth.verification.subtitle': '認証コードを送信しました：',
  'auth.verification.codeLabel': '認証コード',
  'auth.verification.codePlaceholder': '6桁のコードを入力',
  'auth.verification.submit': 'メール認証',
  'auth.verification.resend': 'コードを再送信',
  'auth.verification.resendIn': '再送信まで',
  'auth.verification.seconds': '秒',
  'auth.verification.success': 'メール認証に成功しました！',
  'auth.verification.error': '無効なコードです。もう一度お試しください。',
  'auth.verification.expired': 'コードの期限が切れました。新しいコードをリクエストしてください。',
  'auth.verification.sent': '新しいコードを送信しました！',
  'auth.verification.checkSpam':
    '届きませんでしたか？スパムフォルダを確認してください。',

  // Forgot Password
  'auth.forgot.title': 'パスワードをお忘れですか',
  'auth.forgot.headline': 'パスワードをリセット',
  'auth.forgot.subtitle':
    'メールアドレスを入力してください。リセットリンクをお送りします。',
  'auth.forgot.submit': 'リセットリンクを送信',
  'auth.forgot.backToLogin': 'ログインに戻る',
  'auth.forgot.success': 'メールを送信しました！',
  'auth.forgot.successMessage':
    'パスワードをリセットする方法を記載したメールをお送りしました。',
  'auth.forgot.checkInbox': '受信トレイを確認してください',

  // Reset Password
  'auth.reset.title': '新しいパスワード',
  'auth.reset.headline': '新しいパスワードを設定',
  'auth.reset.subtitle': '新しいパスワードを入力してください。',
  'auth.reset.newPassword': '新しいパスワード',
  'auth.reset.confirmNewPassword': '新しいパスワードを確認',
  'auth.reset.submit': 'パスワードを変更',
  'auth.reset.success': 'パスワードが正常に変更されました！',
  'auth.reset.successMessage':
    '新しいパスワードでサインインできます。',
  'auth.reset.loginNow': '今すぐサインイン',

  // Legal Pages
  'legal.backToAuth': 'ログインに戻る',
  'legal.allRightsReserved': 'All rights reserved.',

  // Terms Page
  'legal.terms.title': '利用規約',
  'legal.terms.lastUpdated': '最終更新日',
  'legal.terms.section1.title': '1. 適用範囲',
  'legal.terms.section1.content':
    '本利用規約は、AI駆動のニッチ分析プラットフォームの使用に関して、NicheFinder（以下「提供者」）とユーザー（以下「顧客」）との間のすべての契約に適用されます。',
  'legal.terms.section2.title': '2. サービス内容',
  'legal.terms.section2.content':
    '提供者は、ビジネスアイデアとニッチを分析・評価するAIベースのプラットフォームを提供します。サービスには以下が含まれます：',
  'legal.terms.section2.item1': 'ビジネスアイデアのAI駆動分析',
  'legal.terms.section2.item2': '市場可能性と競争の評価',
  'legal.terms.section2.item3': 'ニッチ提案の生成',
  'legal.terms.section2.item4': '開発者向けブリーフィングの作成（ビルダーパッケージ）',
  'legal.terms.section3.title': '3. 契約成立と登録',
  'legal.terms.section3.content':
    '契約は、プラットフォームへの登録とパッケージの選択によって成立します。顧客は以下を確認します：',
  'legal.terms.section3.item1': '成年であり、完全な法的能力を有すること',
  'legal.terms.section3.item2': '登録時に真実の情報を提供すること',
  'legal.terms.section3.item3': 'アクセス認証情報を安全に保管すること',
  'legal.terms.section4.title': '4. クレジットと課金',
  'legal.terms.section4.content':
    'AI機能の使用はクレジットシステムに基づきます。各AIクエリは30クレジットを消費します。クレジットは成功したレスポンスに対してのみ差し引かれます。未使用のクレジットは請求期間の終了時に失効し、返金されません。',
  'legal.terms.section5.title': '5. 免責事項',
  'legal.terms.section5.content':
    'AI評価は意思決定の補助としてのみ機能し、ビジネスの成功を保証するものではありません。提供者は、AI分析に基づいて行われた決定に対して責任を負いません。故意および重大な過失に対する責任は影響を受けません。',
  'legal.terms.section6.title': '6. データ保護と機密性',
  'legal.terms.section6.content':
    '提出されたすべてのビジネスアイデアは機密として扱われ、第三者と共有されません。個人データの処理は、プライバシーポリシーおよび適用されるデータ保護法に従って行われます。',
  'legal.terms.section7.title': '7. 解約',
  'legal.terms.section7.content':
    '顧客は、現在の請求期間の終了時にいつでもサブスクリプションを解約できます。本規約に違反した場合、提供者はプラットフォームへのアクセスをブロックする権利を留保します。',
  'legal.terms.section8.title': '8. 最終規定',
  'legal.terms.section8.content':
    'スイス法が適用されます。管轄裁判所はスイスのチューリッヒとします。本規約の個別規定が無効である場合でも、残りの規定の有効性は影響を受けません。',
  'legal.terms.contact.title': '利用規約に関する質問',
  'legal.terms.contact.content':
    '本利用規約についてご質問がある場合は、以下までお問い合わせください：',

  // Privacy Page
  'legal.privacy.title': 'プライバシーポリシー',
  'legal.privacy.section1.title': '1. データ管理者',
  'legal.privacy.section1.content':
    'このウェブサイトのデータ管理者は、スイス、チューリッヒのNicheFinderです。当社はお客様の個人データの保護を非常に重視し、お客様の個人データを機密として、法定のデータ保護規制に従って処理します。',
  'legal.privacy.section2.title': '2. 収集するデータ',
  'legal.privacy.section2.content':
    '当社は以下の個人データを収集および処理します：',
  'legal.privacy.section2.item1':
    '登録データ：氏名、メールアドレス、パスワード（暗号化）',
  'legal.privacy.section2.item2':
    '使用データ：IPアドレス、ブラウザタイプ、アクセス時間',
  'legal.privacy.section2.item3':
    'ビジネスアイデアとニッチクエリ（匿名で保存）',
  'legal.privacy.section2.item4':
    '支払い情報（安全な第三者プロバイダー経由）',
  'legal.privacy.section3.title': '3. データ処理の目的',
  'legal.privacy.section3.content':
    'お客様のデータは以下の目的で使用されます：',
  'legal.privacy.section3.item1':
    'AIサービスの提供と改善',
  'legal.privacy.section3.item2':
    'アカウント管理と認証',
  'legal.privacy.section3.item3':
    '課金と支払い処理',
  'legal.privacy.section4.title': '4. データセキュリティ',
  'legal.privacy.section4.content':
    '当社は、お客様のデータを改ざん、紛失、破壊、または不正アクセスから保護するための技術的および組織的なセキュリティ対策を実施しています。すべてのデータ転送はSSL/TLSで暗号化されます。',
  'legal.privacy.section5.title': '5. ビジネスアイデアの機密性',
  'legal.privacy.section5.content':
    '提出されたビジネスアイデアとニッチクエリは厳密に機密として扱われます。第三者と共有されず、トレーニング目的で使用されず、リクエストに応じて完全に削除できます。お客様のアイデアはお客様のものです。',
  'legal.privacy.section6.title': '6. お客様の権利',
  'legal.privacy.section6.content':
    'お客様は個人データに関して以下の権利を有します：',
  'legal.privacy.section6.item1': '保存されたデータへのアクセス権',
  'legal.privacy.section6.item2': '不正確なデータの訂正権',
  'legal.privacy.section6.item3': 'データの削除権',
  'legal.privacy.section6.item4': 'データポータビリティ権',
  'legal.privacy.section7.title': '7. クッキー',
  'legal.privacy.section7.content':
    '当社のウェブサイトは、認証とセッション管理のために技術的に必要なクッキーのみを使用します。お客様の明示的な同意なしに、トラッキングクッキーや第三者の分析ツールは使用しません。',
  'legal.privacy.section8.title': '8. 本プライバシーポリシーの変更',
  'legal.privacy.section8.content':
    '当社は、変更された法的要件に対応するため、またはサービスの変更時に、このプライバシーポリシーを適応させる権利を留保します。最新版は常にこのページでご覧いただけます。',
  'legal.privacy.contact.title': 'プライバシーに関する質問',
  'legal.privacy.contact.content':
    '個人データの処理についてご質問がある場合は、以下までお問い合わせください：',

  'auth.passwordStrength.label': 'パスワード強度',
  'auth.passwordStrength.weak': '弱い',
  'auth.passwordStrength.medium': '中程度',
  'auth.passwordStrength.strong': '強い',
  'auth.passwordStrength.veryStrong': '非常に強い',
  'auth.passwordStrength.minLength': '最低8文字',
  'auth.passwordStrength.uppercase': '大文字',
  'auth.passwordStrength.number': '数字',
  'auth.passwordStrength.special': '特殊文字',

  trial: {
    subtitle: '無料トライアル',
    upgrade: 'アップグレード',
    creditsRemaining: '残りクレジット',
    inputHint: 'トライアル版 - 会話履歴は利用できません',
    banner: {
      title: '7日間トライアル有効中',
      remaining: '残り{{days}}日',
      credits: '利用可能なクレジット',
      upgradeNow: '今すぐアップグレード',
    },
    welcome: {
      title: '無料トライアルへようこそ！',
      desc: '100クレジットで7日間無料でAIアシスタントをテストできます。質問して可能性を発見してください！',
    },
    info: {
      title: 'トライアルの制限',
      credits: '7日間で100クレジット',
      noHistory: '会話履歴なし',
      noSettings: '制限された機能',
      upgrade: '全機能を利用するにはアップグレード',
    },
  },

  // ─── Settings Page ────────────────────────────────────────────────────────────
  'settings.title': '設定',
  'settings.subtitle': 'アカウントと環境設定を管理',
  'settings.backToOverview': '概要に戻る',
  'settings.subscriptionLink': 'サブスクリプションと請求',
  'settings.saved': '変更が保存されました',
  'settings.changesSaved': '変更を保存',
  'settings.saveChanges': '変更を保存',
  'settings.dataExported': 'データをエクスポートしました',

  // Tabs
  'settings.tabs.profile': 'プロフィール',
  'settings.tabs.preferences': '環境設定',
  'settings.tabs.notifications': '通知',
  'settings.tabs.account': 'アカウントとプラン',

  // Profile
  'settings.profile.changePhoto': '写真を変更',
  'settings.profile.photoHint': 'JPG、PNGまたはGIF（最大2MB）',
  'settings.profile.uploading': 'アップロード中...',
  'settings.profile.photoUpdated': 'プロフィール写真を更新しました！',
  'settings.profile.name': '名前',
  'settings.profile.email': 'メール',
  'settings.profile.phone': '電話番号',
  'settings.profile.changePassword': 'パスワードを変更',
  'settings.profile.currentPassword': '現在のパスワード',
  'settings.profile.newPassword': '新しいパスワード',
  'settings.profile.confirmPassword': 'パスワードを確認',

  // Preferences
  'settings.preferences.language': '言語',
  'settings.preferences.chooseLanguage': '言語を選択',
  'settings.preferences.timezone': 'タイムゾーン',
  'settings.preferences.currency': '通貨',

  // Notifications
  'settings.notifications.emailTitle': 'メール通知',
  'settings.notifications.email.analysis': '分析完了',
  'settings.notifications.email.analysisDesc': '分析準備完了時にメールを受信',
  'settings.notifications.email.credits': 'クレジット更新',
  'settings.notifications.email.creditsDesc': 'クレジットとリセットに関する通知',
  'settings.notifications.email.billing': '請求書と支払い',
  'settings.notifications.email.billingDesc': '請求書とプラン変更に関する通知',
  'settings.notifications.email.newsletter': 'ニュースレター',
  'settings.notifications.email.newsletterDesc': 'ヒント、更新情報、新機能',
  'settings.notifications.pushTitle': 'プッシュ通知',
  'settings.notifications.push.analysis': '分析完了',
  'settings.notifications.push.analysisDesc': '分析準備完了時のブラウザ通知',
  'settings.notifications.push.credits': 'クレジット警告',
  'settings.notifications.push.creditsDesc': 'クレジット残高が少ない場合の警告',

  // Account
  'settings.account.currentSubscription': '現在のサブスクリプション',
  'settings.account.plan': 'プラン',
  'settings.account.price': '価格',
  'settings.account.nextBilling': '次の請求',
  'settings.account.manageSubscription': 'サブスクリプションと支払いを管理',
  'settings.account.dataPrivacy': 'データとプライバシー',
  'settings.account.exportData': 'データをエクスポート',
  'settings.account.deleteAccount': 'アカウントを削除',

  // Delete Modal
  'settings.deleteModal.title': 'アカウントを削除しますか？',
  'settings.deleteModal.subtitle': 'すべてのデータが完全に削除されます。',
  'settings.deleteModal.warning1': 'すべての分析とデータが削除されます',
  'settings.deleteModal.warning2': 'アクティブなサブスクリプションは直ちに解約されます',
  'settings.deleteModal.warning3': '返金はできません',
  'settings.deleteModal.confirmLabel': '確認のため「{{word}}」と入力してください *',
  'settings.deleteModal.cancel': 'キャンセル',
  'settings.deleteModal.confirm': 'アカウントを削除',

  // ─── Subscription & Billing ─────────────────────────────────────────────────
  'sub.backToOverview': '概要に戻る',
  'sub.settings': '設定',
  'sub.title': 'サブスクリプションと請求',
  'sub.subtitle': 'サブスクリプション、支払い方法、請求書を管理',
  'sub.tab.overview': '概要',
  'sub.tab.payment': '支払い方法',
  'sub.tab.billing': '請求先住所',
  'sub.tab.history': '支払い履歴',
  'sub.memberSince': '利用開始',
  'sub.perMonth': '/月',
  'sub.baseCHF': '（CHF {{amount}} 基本）',
  'sub.nextBilling': '次の請求',
  'sub.creditsUsed': '使用クレジット',
  'sub.paymentMethod': '支払い方法',
  'sub.creditUsage': 'クレジット使用量',
  'sub.changePlan': 'プランを変更',
  'sub.reactivate': '再開',
  'sub.cancelSub': 'サブスクリプションを解約',
  'sub.manageCards': 'カードを管理',
  'sub.downloadInvoices': '請求書をダウンロード',
  'sub.invoicesAvailable': '{{count}}件の請求書がPDFで利用可能',
  'sub.accountSettings': 'アカウント設定',
  'sub.profileNotifications': 'プロフィール、通知など',
  // Prices in EUR info
  'sub.eurInfo': '表示価格は',
  'sub.eurLabel': 'ユーロ',
  'sub.eurRate': 'レート：',
  'sub.currentRate': '現在のレート',
  // Payment Methods
  'sub.savedCards': '保存されたカード',
  'sub.newCard': '新しいカード',
  'sub.default': 'デフォルト',
  'sub.setDefault': 'デフォルトに設定',
  'sub.validUntil': '有効期限',
  'sub.noCards': '保存されたカードはありません',
  'sub.addFirstCard': '最初のカードを追加',
  'sub.securePayments': '安全な支払い',
  'sub.securePaymentsDesc': 'すべての支払いデータは暗号化され、当社の支払いプロバイダーに安全に保存されます。完全なカード番号は保存しません。',
  // Billing Address
  'sub.billingAddress': '請求先住所',
  'sub.edit': '編集',
  'sub.name': '名前',
  'sub.streetAddress': '住所',
  'sub.zip': '郵便番号',
  'sub.city': '市区町村',
  'sub.country': '国',
  'sub.address': '住所',
  'sub.save': '保存',
  'sub.cancel': 'キャンセル',
  'sub.country.switzerland': 'スイス',
  'sub.country.germany': 'ドイツ',
  'sub.country.austria': 'オーストリア',
  'sub.country.netherlands': 'オランダ',
  'sub.country.belgium': 'ベルギー',
  // Payment History
  'sub.paymentHistory': '支払い履歴',
  'sub.allInvoicesPDF': 'すべての請求書をPDF（ロゴ付き）でダウンロード',
  'sub.downloadAll': 'すべてダウンロード',
  'sub.eurInvoiceNote': '請求書は常にCHFで発行されます。表示されるEUR金額は参考のみです。',
  'sub.date': '日付',
  'sub.description': '説明',
  'sub.net': '正味',
  'sub.vat': '消費税',
  'sub.total': '合計',
  'sub.status': 'ステータス',
  'sub.pdf': 'PDF',
  'sub.invoices': '請求書',
  'sub.totalAmount': '合計金額',
  // Change Plan Modal
  'sub.changePlanTitle': 'プランを変更',
  'sub.current': '現在',
  'sub.month': '/月',
  'sub.showLess': '表示を減らす',
  'sub.showMore': '+{{count}}件表示',
  'sub.switchPlan': 'プランを切り替え',
  'sub.eurPriceNote': '価格はEURで表示（{{note}}）。請求はCHFです。',
  // Cancel Modal
  'sub.cancelTitle': '本当にサブスクリプションを解約しますか？',
  'sub.cancelIrreversible': 'この操作は元に戻せません。',
  'sub.cancelWarning1': 'すべての残りクレジットが失効します',
  'sub.cancelWarning2': '無料プランにダウングレード',
  'sub.cancelWarning3': 'すべてのプレミアム機能が失われます',
  'sub.pauseInstead': '代替案：サブスクリプションを一時停止しますか？',
  'sub.pauseDesc': '代わりにサブスクリプションを一時停止し、データを維持してください。',
  'sub.preferPause': '一時停止を希望',
  'sub.cancelReason': '解約理由',
  'sub.selectReason': '選択してください...',
  'sub.reason.tooExpensive': '高すぎる',
  'sub.reason.notUsing': 'あまり使用していない',
  'sub.reason.missingFeatures': '機能が不足している',
  'sub.reason.foundAlternative': '代替品を見つけた',
  'sub.reason.other': 'その他',
  'sub.confirmType': '確認：「CANCEL」と入力してください *',
  'sub.cancelNow': '今すぐ解約',
  // Add Card Modal
  'sub.addCardTitle': '新しいカードを追加',
  'sub.cardHolder': 'カード名義人 *',
  'sub.cardNumber': 'カード番号 *',
  'sub.expiryDate': '有効期限 *',
  'sub.addCard': 'カードを追加',
  // Change Card Modal
  'sub.choosePayment': '支払い方法を選択',
  'sub.active': 'アクティブ',
  'sub.close': '閉じる',
  // Toast messages
  'sub.toast.cancelled': 'サブスクリプションは請求期間の終了時に解約されました。',
  'sub.toast.reactivated': 'サブスクリプションが正常に再開されました！',
  'sub.toast.planChanged': 'プランが{{plan}}に正常に変更されました！',
  'sub.toast.defaultChanged': 'デフォルトの支払い方法が変更されました。',
  'sub.toast.cannotDeleteDefault': 'デフォルトのカードは削除できません。',
  'sub.toast.cardRemoved': 'カードが削除されました。',
  'sub.toast.fillAll': 'すべての項目を入力してください。',
  'sub.toast.cardAdded': '新しいカードが正常に追加されました！',
  'sub.toast.billingSaved': '請求先住所を保存しました。',
  'sub.toast.invoiceDownloaded': '請求書{{id}}をダウンロードしました！',
  'sub.toast.pdfError': 'PDFの作成中にエラーが発生しました。',
  // Chat interface
  'sub.notEnoughCredits': 'クレジットが不足しています',
  'sub.needCredits': '質問には少なくとも{{count}}クレジットが必要です。',
  'sub.creditsLow': 'クレジット残量が少ない',
  'sub.questionsLeft': '{{count}}件の質問が可能です。',
  'sub.plan': 'プラン',
  'sub.base': '基本',
  'sub.unlimited': '無制限',
  'sub.status.active': 'アクティブ',
  'sub.status.cancelled': '解約済み',
  'sub.status.paused': '一時停止中',
  'sub.invoice': '請求書',
  'sub.from': '差出人',
  'sub.to': '宛先',
  'sub.vatId': '消費税登録番号',
  'sub.tel': '電話',
  'sub.invoiceDate': '請求日',
  'sub.invoiceNumber': '請求書番号',
  'sub.paymentStatus': '支払い状況',
  'sub.creditCard': 'クレジットカード',
  'sub.quantity': '数量',
  'sub.price': '単価',
  'sub.amount': '金額',
  'sub.subtotal': '小計',
  'sub.bank': '銀行',
  'sub.card': 'カード',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'John Doe',

  // ─── Admin Panel ─────────────────────────────────────────────────────────────
  'admin.title': '管理者ダッシュボード',
  'admin.subtitle': 'コントロールセンター',
  'admin.superAdmin': 'スーパー管理者',
  'admin.logout': 'ログアウト',
  'admin.tabs.users': 'ユーザー管理',
  'admin.tabs.downgrades': 'ダウングレード',
  'admin.tabs.tips': '今日のヒント',
  'admin.tabs.coupons': 'クーポンコード',
  'admin.tabs.website': 'ウェブサイト編集',
  'admin.tabs.ai': 'AI設定',
  'admin.tabs.transactions': '取引ログ',
  'admin.tabs.stats': '統計',
  'admin.users.searchPlaceholder': 'ユーザーを検索（メールまたは名前）...',
  'admin.users.manageSubscription': 'サブスクリプションを管理',
  'admin.users.grantFree': '無料アカウントを付与',
  'admin.users.blockUser': 'ユーザーをブロック',
  'admin.users.cancellationPlaceholder': 'サブスクリプション解約理由は？',
  'admin.users.selectPlan': 'プランを選択',
  'admin.users.subChanged': '{{name}}のサブスクリプションを{{plan}}に変更しました',
  'admin.users.noReasonGiven': '理由なし',
  'admin.users.subCancelled': '{{name}}のサブスクリプションを解約しました（{{date}}まで有効）',
  'admin.users.paused': '一時停止中',
  'admin.users.subPaused': '{{name}}のサブスクリプションを一時停止しました',
  'admin.users.subReactivated': '{{name}}のサブスクリプションを再開しました',
  'admin.users.freeAccount': '無料アカウント',
  'admin.users.blocked': 'ブロック済み',
  'admin.users.cancelledExpiring': '解約済み（期限切れ予定）',
  'admin.users.cancelledOn': '解約日：',
  'admin.users.endsOn': '終了日：',
  'admin.users.daysRemaining': '残り日数',
  'admin.users.expired': '（期限切れ）',
  'admin.users.total': '合計：',
  'admin.users.usersLabel': 'ユーザー',
  'admin.users.free': '無料',
  'admin.users.block': 'ブロック',
  'admin.users.unblock': 'ブロック解除',
  'admin.users.unblockUser': 'ユーザーのブロックを解除',
  'admin.users.selectAction': 'アクションを選択',
  'admin.users.cancelSub': 'サブスクリプションを解約',
  'admin.users.cancelSubDesc': '月末で解約',
  'admin.users.pauseSub': 'サブスクリプションを一時停止',
  'admin.users.pauseSubDesc': '一時停止',
  'admin.users.changePlan': 'プランを変更',
  'admin.users.changePlanDesc': '別のプランに切り替え',
  'admin.users.reactivateSub': 'サブスクリプションを再開',
  'admin.users.reactivateDesc': '解約を取り消す',
  'admin.users.alreadyCancelled': 'サブスクリプションは既に解約済み',
  'admin.users.planLabel': 'プラン',
  'admin.users.cancellationReasonOpt': '解約理由（任意）',
  'admin.users.cancelInfo1': 'サブスクリプションは',
  'admin.users.cancelInfo2': '（月末）に終了します。それまではユーザーは完全なアクセス権を持ちます。返金はありません。',
  'admin.users.newPlan': '新しいプラン',
  'admin.users.warning': '警告',
  'admin.users.blockDesc': 'ユーザーは直ちにログアウトされ、再ログインできなくなります。すべてのアクティブセッションが終了します。',
  'admin.users.confirmUnblock': 'ブロック解除を確認',
  'admin.users.unblockDesc': 'ユーザーは再ログインしてすべての機能を使用できます。',
  'admin.users.afterBlock': 'ブロック後：',
  'admin.users.afterUnblock': 'ブロック解除後：',
  'admin.users.noAccountAccess': 'アカウントアクセス不可',
  'admin.users.noNewAnalyses': '新しい分析は不可能',
  'admin.users.creditsStored': 'クレジットと履歴は保持されます',
  'admin.users.accessRestored': 'アカウントアクセスが復元されました',
  'admin.users.allFeaturesAvail': 'すべての機能が再び利用可能になりました',
  'admin.users.creditsPreserved': 'クレジットと履歴は保持されます',
  'admin.users.downgrade': 'プランをダウングレード',
  'admin.users.grantFreeBtn': '無料付与',
  'admin.users.durationMonths': '期間（ヶ月）',
  'admin.users.months': 'ヶ月',
  'admin.users.freePlan': '無料',
  'admin.users.freeSummary': 'を受け取る',
  'admin.users.withCredits': '（クレジット：',
  'admin.users.credits': 'クレジット',
  'admin.users.subInfo': 'サブスクリプション情報',
  'admin.users.currentPlan': '現在のプラン',
  'admin.users.joined': '登録日',
  'admin.users.totalSpent': '総支出',
  'admin.users.paymentMethod': '支払い方法',
  'admin.users.validThrough': '有効期限',
  'admin.users.billingAddress': '請求先住所',
  'admin.users.transactionHistory': '取引履歴',
  'admin.users.cancellationDate': '解約日',
  'admin.users.validUntil': '有効期限（月末）',
  'admin.users.cancellationReason': '解約理由',
  'admin.users.noReason': '理由なし',
  'admin.users.timeRemaining': '残り時間',
  'admin.users.daysUntilDeactivation': '無効化までの日数',
  'admin.table.user': 'ユーザー',
  'admin.table.plan': 'プラン',
  'admin.table.subStatus': 'サブスクリプション状況',
  'admin.table.cancellation': '解約',
  'admin.table.payment': '支払い方法',
  'admin.table.spending': '支出',
  'admin.table.actions': 'アクション',
  'admin.actions.viewDetails': '詳細を見る',
  'admin.actions.manageSubscription': 'サブスクリプションを管理',
  'admin.actions.grantFree': '無料アクセスを付与',
  'admin.actions.block': 'ユーザーをブロック',
  'admin.actions.unblock': 'ユーザーのブロックを解除',
  'admin.actions.cancel': 'キャンセル',
  'admin.actions.save': '保存',
  'admin.actions.delete': '削除',
  'admin.actions.confirm': '確認',
  'admin.actions.done': '完了',
  'admin.actions.edit': '編集',
  'admin.actions.close': '閉じる',
  'admin.table.status': 'ステータス',
  'admin.filter.all': 'すべて',
  'admin.subscription.active': 'アクティブ',
  'admin.subscription.cancelled': '解約済み',
  'admin.subscription.paused': '一時停止中',
  'admin.subscription.unknown': '不明',
  'admin.status.active': 'アクティブ',
  'admin.status.inactive': '非アクティブ',
  'admin.status.pending': '保留中',
  'admin.status.approved': '承認済み',
  'admin.status.rejected': '却下',
  'admin.coupons.title': 'クーポン管理',
  'admin.coupons.subtitle': 'クーポンコードを作成・管理',
  'admin.coupons.newCoupon': '新規クーポン',
  'admin.coupons.registrationCoupons': '登録用クーポン',
  'admin.coupons.trialCoupons': 'トライアルアクセスクーポン',
  'admin.coupons.type': 'タイプ',
  'admin.coupons.plan': 'プラン',
  'admin.coupons.value': '価値',
  'admin.coupons.usage': '使用状況',
  'admin.coupons.validUntil': '有効期限',
  'admin.coupons.created': '作成日',
  'admin.coupons.actions': 'アクション',
  'admin.coupons.copyCode': 'コードをコピー',
  'admin.coupons.allPlans': 'すべてのプラン',
  'admin.coupons.discount': '割引',
  'admin.coupons.days': '日間',
  'admin.coupons.months': 'ヶ月間',
  'admin.coupons.free': '無料',
  'admin.coupons.unlimited': '無制限',
  'admin.coupons.createRegistration': '登録用クーポンを作成',
  'admin.coupons.createTrial': 'トライアルアクセスクーポンを作成',
  'admin.coupons.couponCode': 'クーポンコード',
  'admin.coupons.codePlaceholder': '例：NF-7X3K9M',
  'admin.coupons.generateCode': '新しいコードを生成',
  'admin.coupons.alertFillRequired': '必須項目をすべて入力してください',
  'admin.coupons.alertSelectExpiry': '有効期限を選択するか、「無制限の有効性」を有効にしてください',
  'admin.coupons.alertCreateError': 'クーポン作成エラー',
  'admin.coupons.confirmDelete': 'このクーポンを削除してもよろしいですか？',
  'admin.coupons.discountPercent': '割引（%）',
  'admin.coupons.bonusCredits': 'ボーナスクレジット',
  'admin.coupons.freeDuration': '無料期間',
  'admin.coupons.maxUses': '最大使用回数',
  'admin.coupons.expiryDate': '有効期限',
  'admin.coupons.unlimitedValidity': '無制限の有効性',
  'admin.coupons.unlimitedUses': '無制限の使用',
  'admin.coupons.trialCredits': 'トライアルクレジット',
  'admin.coupons.trialDuration': 'トライアル期間',
  'admin.coupons.typePlaceholder': '例：早期割引、パートナー、インフルエンサー',
  'admin.coupons.duration': '期間',
  'admin.stats.totalUsers': '総ユーザー数',
  'admin.stats.monthlyRevenue': '月間収益',
  'admin.stats.activeSubscriptions': 'アクティブサブスクリプション',
  'admin.stats.average': '平均',
  'admin.stats.revenuePerUser': 'ユーザーあたりの収益',
  'admin.stats.grossRevenue': '総収益',
  'admin.stats.net': '純',
  'admin.stats.netRevenue': '純収益',
  'admin.stats.churnRate': '解約率',
  'admin.stats.planDistribution': 'プラン分布',
  'admin.stats.users': 'ユーザー',
  'admin.stats.revenueByPlan': 'プラン別収益',
  'admin.stats.recentActivity': '最近のアクティビティ',
  'admin.stats.activity1': 'Thomas Weberがビルダーにアップグレード',
  'admin.stats.activity2': '新規ユーザー登録',
  'admin.stats.activity3': 'Anna Schmidtがプロにアップグレード',
  'admin.stats.hoursAgo2': '2時間前',
  'admin.stats.hoursAgo5': '5時間前',
  'admin.stats.dayAgo1': '1日前',
  'admin.stats.couponStats': 'クーポン統計',
  'admin.stats.totalRedemptions': '総使用回数',
  'admin.stats.activeCoupons': 'アクティブなクーポン',
  'admin.stats.registrationRedemptions': '登録用使用回数',
  'admin.stats.trialRedemptions': 'トライアル使用回数',
  'admin.stats.couponDistribution': 'クーポン分布',
  'admin.stats.registrationCoupons': '登録用クーポン',
  'admin.stats.trialCoupons': 'トライアルクーポン',
  'admin.stats.expiredInactive': '期限切れ/非アクティブ',
  'admin.stats.topCoupons': '使用回数トップのクーポン',
  'admin.stats.redemptions': '使用回数',
  'admin.stats.noCouponsRedeemed': 'まだ使用されたクーポンはありません',
  'admin.downgrade.pending': '保留中',
  'admin.downgrade.refunds': '返金',
  'admin.downgrade.sectionRequests': 'リクエスト',
  'admin.downgrade.sectionStats': '統計',
  'admin.downgrade.sectionRules': 'ルール',
  'admin.downgrade.pendingRequests': '保留中のリクエスト',
  'admin.downgrade.approvedRequests': '承認済みリクエスト',
  'admin.downgrade.rejectedRequests': '却下されたリクエスト',
  'admin.downgrade.activeRules': 'アクティブルール',
  'admin.downgrade.autoRules': '自動ダウングレードルール',
  'admin.downgrade.autoRulesDesc': '使用状況に基づいて自動的にダウングレードをトリガーするルールを作成',
  'admin.downgrade.newRule': '新規ルール',
  'admin.downgrade.totalRules': '総ルール数',
  'admin.downgrade.triggeredActions': 'トリガーされたアクション',
  'admin.downgrade.conditionsAnd': '条件（ANDで連結）',
  'admin.downgrade.action': 'アクション',
  'admin.downgrade.successTitle': 'ダウングレード成功！',
  'admin.downgrade.successDesc': 'ユーザーは正常にダウングレードされ、返金が処理されました。',
  'admin.downgrade.closing': '閉じる...',
  'admin.downgrade.title': 'ユーザーをダウングレード',
  'admin.downgrade.currentPlan': '現在のプラン',
  'admin.downgrade.spending': '支出',
  'admin.downgrade.availablePlans': 'ダウングレード可能なプラン',
  'admin.downgrade.perMonth': '/月',
  'admin.downgrade.refundCalc': '返金計算',
  'admin.downgrade.currentPlanLabel': '現在のプラン',
  'admin.downgrade.newPlan': '新しいプラン',
  'admin.downgrade.remainingDays': '残り日数',
  'admin.downgrade.daysOf': '30日中15日',
  'admin.downgrade.proRataRefund': '日割り返金',
  'admin.downgrade.importantNote': '重要事項',
  'admin.downgrade.warningDesc': 'ダウングレードは直ちに実行されます。ユーザーはプレミアム機能へのアクセスを失い、超過クレジットは削除されます。',
  'admin.downgrade.processing': '処理中...',
  'admin.downgrade.execute': 'ダウングレードを実行',
  'admin.downgrade.notification': '通知',
  'admin.downgrade.noNotification': '通知なし',
  'admin.downgrade.daysPeriod': '日間の猶予期間',
  'admin.downgrade.created': '作成日：',
  'admin.downgrade.triggered': 'トリガー済み',
  'admin.downgrade.noRules': 'ルールが作成されていません',
  'admin.downgrade.createFirstRule': '最初のルールを作成',
  'admin.downgrade.editRule': 'ルールを編集',
  'admin.downgrade.createRule': '新規ルールを作成',
  'admin.downgrade.ruleName': 'ルール名',
  'admin.downgrade.description': '説明',
  'admin.downgrade.allConditions': '条件（すべて満たす必要あり）',
  'admin.downgrade.addCondition': '条件を追加',
  'admin.downgrade.type': 'タイプ',
  'admin.downgrade.value': '値',
  'admin.downgrade.fromPlan': '元のプラン',
  'admin.downgrade.toPlan': '対象プラン',
  'admin.condition.inactivity': '非アクティブ',
  'admin.condition.creditUsage': 'クレジット使用量',
  'admin.condition.loginFrequency': 'ログイン頻度',
  'admin.condition.featureUsage': '機能使用量',
  'admin.condition.supportTickets': 'サポートチケット',
  'admin.operator.lessThan': '未満',
  'admin.operator.greaterThan': '超過',
  'admin.operator.equals': '一致',
  'admin.operator.between': 'の間',
  'admin.unit.days': '日',
  'admin.unit.perMonth': '/月',
  'admin.unit.count': '回数',
  'admin.transactions.all': 'すべての取引',
  'admin.transactions.allCards': 'すべてのカード',
  'admin.transactions.notFound': '取引が見つかりません',
  'admin.transactions.totalLabel': '合計',
  'admin.transactions.transactions': '取引',
  'admin.tips.title': '今日のヒント',
  'admin.tips.subtitle': 'すべてのユーザーに表示されるヒントを作成・管理',
  'admin.tips.active': 'アクティブ',
  'admin.tips.currentlyShown': 'このヒントは現在すべてのユーザーに表示されています',
  'admin.tips.createNew': '新しいヒントを作成',
  'admin.tips.generating': '生成中...',
  'admin.tips.generateAI': 'AIヒントを生成',
  'admin.tips.titleLabel': 'タイトル',
  'admin.tips.titlePlaceholder': '例：今日のヒント',
  'admin.tips.category': 'カテゴリー',
  'admin.tips.categoryTip': 'ヒント',
  'admin.tips.categoryFeature': '新機能',
  'admin.tips.categoryProductivity': '生産性',
  'admin.tips.categoryUpdate': 'アップデート',
  'admin.tips.content': '内容',
  'admin.tips.contentPlaceholder': 'ここにユーザー向けのヒントを記入...',
  'admin.tips.addTip': 'ヒントを追加',
  'admin.tips.allTips': 'すべてのヒント',
  'admin.tips.noTips': 'まだヒントが作成されていません',
  'admin.tips.noTipsHint': '「AIヒントを生成」をクリックして開始してください',
  'admin.noData': 'データがありません',
  'admin.range.7d': '7日間',
  'admin.range.30d': '30日間',
  'admin.range.90d': '90日間',
  'admin.range.1y': '1年間',
  'admin.actions.saveSettings': '設定を保存',
  'admin.actions.create': '作成',
  'admin.downgrade.sectionReports': 'レポート',
  'admin.downgrade.settings': 'ダウングレード設定',
  'admin.downgrade.autoApprove': '自動承認',
  'admin.downgrade.autoApproveDesc': 'ダウングレードリクエストを自動的に承認',
  'admin.downgrade.refundPolicy': '返金ポリシー',
  'admin.downgrade.prorata': '日割り返金',
  'admin.downgrade.prorataDesc': '残り日数に基づく比例返金',
  'admin.downgrade.fullRefund': '全額返金',
  'admin.downgrade.fullRefundDesc': '価格差の全額返金',
  'admin.downgrade.noRefund': '返金なし',
  'admin.downgrade.noRefundDesc': '返金なしのダウングレード',
  'admin.downgrade.daysRemaining15': '（残り15日の場合）',
  'admin.downgrade.requestsTitle': 'ダウングレードリクエスト',
  'admin.downgrade.approvalRate': '承認率',
  'admin.downgrade.mostCommonTransition': '最も一般的な移行',
  'admin.downgrade.mostCommonReason': '最も一般的な理由',
  'admin.downgrade.avgProcessingTime': '平均処理時間',
  'admin.downgrade.avgTimeDesc': '決定までの平均時間',
  'admin.downgrade.totalRefunds': '総返金額',
  'admin.downgrade.pendingRefunds': '保留中の返金',
  'admin.downgrade.summary': 'サマリー',
  'admin.downgrade.total': '合計',
  'admin.downgrade.csvDesc': 'Excel、Google Sheets用',
  'admin.downgrade.downloadCSV': 'CSVとしてダウンロード',
  'admin.downgrade.jsonDesc': '開発者、API用',
  'admin.downgrade.downloadJSON': 'JSONとしてダウンロード',
  'admin.downgrade.exportInfo': 'エクスポートには',
  'admin.downgrade.entries': '選択期間からのエントリーが含まれます',
  'admin.downgrade.topReasons': '最も多いダウングレード理由',
  'admin.downgrade.refundHistory': '返金履歴',
  'admin.downgrade.noRefunds': 'まだ返金はありません',
  'admin.downgrade.statistics': 'ダウングレード統計',
  'admin.downgrade.requests': 'リクエスト',
  'admin.downgrade.monthlyTrend': '月間傾向',
  'admin.downgrade.planTransitions': 'プラン移行',
  'admin.downgrade.trend': '傾向（前月比）',
  'admin.downgrade.trendDesc': 'ダウングレードが少ないほど良い',
  'admin.coupons.allPlansUniversal': 'すべてのプラン（ユニバーサル）',
  'admin.coupons.onlyStarter': 'スターターのみ',
  'admin.coupons.onlyPro': 'プロのみ',
  'admin.coupons.onlyBuilder': 'ビルダーのみ',
  'admin.coupons.allPlansHint': 'ユニバーサルクーポンには「すべてのプラン」を選択',
  'admin.coupons.discountOptional': '割引%（任意）',
  'admin.coupons.discountPlaceholder': '例：50（50%割引の場合）',
  'admin.coupons.bonusCreditsOptional': 'ボーナスクレジット（任意）',
  'admin.coupons.bonusCreditsPlaceholder': '例：500',
  'admin.coupons.freeDurationOptional': '無料期間（任意）',
  'admin.coupons.durationPlaceholder': '例：30',
  'admin.coupons.freeDurationHint': '例：30日間無料使用',
  'admin.coupons.noLimit': '使用制限なし',
  'admin.coupons.noExpiry': '有効期限なし',
  'admin.coupons.creditsPlaceholder': '例：100',
  'admin.coupons.creditsHint': 'トライアルアクセスのクレジット数',
  'admin.coupons.trialDurationHint': 'トライアルアクセスの有効期間',
  'admin.coupons.autoCalculated': 'トライアル期間から自動計算',
  'admin.websiteEditor.title': 'ウェブサイト編集',
  'admin.websiteEditor.subtitle': 'ホームページのすべてのセクションを編集',
  'admin.websiteEditor.openPreview': 'プレビューを開く',
  'admin.websiteEditor.group.structure': 'ページ構造',
  'admin.websiteEditor.group.design': 'デザインとレイアウト',
  'admin.websiteEditor.group.settings': '設定',
  'admin.websiteEditor.tab.navbar': 'ナビゲーション',
  'admin.websiteEditor.tab.howitworks': '仕組み',
  'admin.websiteEditor.tab.about': '会社概要',
  'admin.websiteEditor.tab.pricing': '料金プラン',
  'admin.websiteEditor.tab.sections': 'セクション',
  'admin.websiteEditor.tab.media': 'メディア',
  'admin.websiteEditor.tab.chatwidget': 'チャット',
  'admin.websiteEditor.tab.invoice': '請求書',
  'admin.websiteEditor.tab.legal': '法的情報',
  'admin.websiteEditor.tab.seo': 'SEO基本',
  'admin.websiteEditor.tab.advancedseo': 'SEO高度',
  'admin.websiteEditor.tab.versions': 'バージョン',
  'admin.hero.title': 'ヒーローセクションを編集',
  'admin.hero.subtitle': 'ホームページのテキスト、ボタン、統計',
  'admin.hero.reset': 'リセット',
  'admin.hero.save': '保存',
  'admin.hero.savedMsg': 'ヒーローデータを保存しました！',
  'admin.hero.badge': 'バッジテキスト',
  'admin.hero.headings': '見出し',
  'admin.hero.line1White': '行1（白）',
  'admin.hero.line2Gold': '行2（ゴールド）',
  'admin.hero.subtitleSection': 'サブタイトル',
  'admin.hero.line1': '行1',
  'admin.hero.line2': '行2',
  'admin.hero.buttons': 'ボタン',
  'admin.hero.primaryBtn': 'プライマリボタン（ゴールド）',
  'admin.hero.secondaryBtn': 'セカンダリボタン（ボーダー）',
  'admin.hero.stats': '統計',
  'admin.hero.statN': '統計 {{n}}',
  'admin.hero.value': '値',
  'admin.hero.label': 'ラベル',
  'admin.hero.previewNote': '変更は保存後にホームページで表示されます。プレビューを表示するにはページをリロードしてください。',

  // Idea History
  'history.title': 'アイデア履歴',
  'history.countLabel': '{{count}}件の分析',
  'history.recentLabel': '最近の分析',
  'history.exportAll': 'すべてエクスポート',
  'history.metrics.marketSize': '市場規模',
  'history.metrics.competition': '競争',
  'history.metrics.startingCapital': '初期資本',
  'history.metrics.timeToMarket': '市場投入までの時間',
  'history.metrics.profitPotential': '収益可能性',
  'history.metrics.scalability': 'スケーラビリティ',
  'history.summary.title': 'サマリー',
  'history.download': 'ダウンロード',
  'history.downloadJSON': 'JSONとして保存',
  'history.downloadTXT': 'TXTとして保存',
  'history.downloadPDF': 'PDFとして保存',
  'history.fullAnalysis': '完全な分析',
  'history.searchPlaceholder': 'タイトルまたはタグで検索...',
  'history.filterAll': 'すべての評価',
  'history.loading': '分析を読み込み中...',
  'history.noResults': '結果が見つかりません',
  'history.empty': 'まだ分析がありません',
  'history.emptyHint': 'AIアシスタントで分析を開始してください',
  'history.delete': '削除',
  'history.cancel': 'キャンセル',
  'history.deleteModalTitle': '分析を削除しますか？',
  'history.deleteModalDesc': '「{{title}}」は完全に削除されます。',
  'history.errorLoading': '分析の読み込みエラー',
  'history.deleteSuccess': '分析を削除しました',
  'history.deleteError': '分析の削除エラー',
  'history.jsonExported': 'JSONをエクスポートしました',
  'history.txtExported': 'TXTをエクスポートしました',
  'history.allExported': '{{count}}件のアイデアをエクスポートしました',
  'history.analysisHeader': 'アイデア分析',
  'history.titleLabel': 'タイトル',
  'history.ratingLabel': '評価',
  'history.dateLabel': '日付',
  'history.creditsLabel': 'クレジット',
  'history.analysisSection': '分析',

  // Overview
  'overview.title': '概要',
  'overview.last24h': '過去24時間',
  'overview.analysesToday': '今日の分析',
  'overview.totalAnalyses': '総分析数',
  'overview.successRate': '成功率',
  'overview.topRatings': 'トップ評価',
  'overview.recentActivity': '最近のアクティビティ',
  'overview.viewAll': 'すべて表示',
  'overview.quickAccess': 'クイックアクセス',
  'overview.quick.newAnalysis': '新しい分析を開始',
  'overview.quick.newAnalysisDesc': '新しいAI駆動のニッチ分析を開始',
  'overview.quick.myAnalyses': 'マイ分析',
  'overview.quick.myAnalysesDesc': 'すべての過去の分析を表示',
  'overview.quick.buyCredits': 'クレジットを購入',
  'overview.quick.buyCreditsDesc': 'より多くの分析のための追加クレジット',
  'overview.quick.settings': '設定',
  'overview.quick.settingsDesc': 'プロフィールと環境設定をカスタマイズ',
  'overview.unlimitedCredits': '無制限のクレジットが利用可能',
  'overview.creditsAvailable': '利用可能なクレジット',
  'overview.upgradePlan': 'プランをアップグレード',
  'overview.buyCredits': 'クレジットを購入',
  'overview.creditUsage': '今月のクレジット使用量',
  'overview.available': '利用可能',

  // --- Admin New Keys ---
  'admin.transactions.upgrades': 'アップグレード',
  'admin.transactions.downgrades': 'ダウングレード',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',

  'admin.users.grantFreeSuccess': '{{name}}は{{months}}ヶ月間の無料{{plan}}プランになりました',
  'admin.users.blockSuccess': '{{name}}をブロックしました',
  'admin.users.unblockSuccess': '{{name}}のブロックを解除しました',
  'admin.users.removeFreeSuccess': '{{name}}の無料ステータスを削除しました',

  'admin.downgrade.plans.builder': 'ビルダー',
  'admin.downgrade.plans.pro': 'プロ',
  'admin.downgrade.plans.starter': 'スターター',
  'admin.downgrade.plans.free': '無料',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': '新機能を発見',
  'admin.tips.productivityBoost': '生産性向上',
  'admin.tips.importantUpdate': '重要なアップデート',
  'admin.tips.tipOfDay': '今日のヒント',

  'admin.actions.activate': '有効化',
  'admin.actions.deactivate': '無効化',
  'admin.websiteEditor.tab.features': '機能',
  'admin.websiteEditor.tab.testimonials': 'お客様の声',
  'admin.websiteEditor.tab.faq': 'よくある質問',
  'admin.websiteEditor.tab.cta': 'CTA',
  'admin.websiteEditor.tab.footer': 'フッター',
  'admin.websiteEditor.tab.design': 'デザイン',
  'admin.websiteEditor.tab.customcode': 'カスタムコード',
  'admin.websiteEditor.tab.socials': 'ソーシャルメディア',
  'admin.websiteEditor.tab.importexport': 'インポート/エクスポート',

  // --- AI Settings Editor ---
  'admin.ai.title': 'AIアシスタント設定',
  'admin.ai.subtitle': '動作、スタイル、分析の深さを設定',
  'admin.ai.smartWeightingActive': 'スマート重み付け有効',
  'admin.ai.smartWeightingDesc': 'AIはすべての視点をスマートな重み付けで自動的に組み合わせます。複数のプリセットがある場合、最初のプリセットが最も重く（プライマリプリセット）重み付けされます。手動で重み付けを調整することもできます。',
  'admin.ai.modelTitle': 'IdeaVerdict AIモデル',
  'admin.ai.modelSubtitle': 'すべてのユーザー分析に使用するAIエンジンを選択',
  'admin.ai.activeModel': 'アクティブなモデル：',
  'admin.ai.activeModelDesc': 'すべてのユーザーはこのモデルからの応答を受け取ります。',
  'admin.ai.recommendations': '最適な結果のための推奨事項',
  'admin.ai.new': '新規',
  'admin.ai.recommendationsDesc': '最高の分析品質のために実績のあるプリセットの組み合わせ',
  'admin.ai.recommendationsInfo': 'これらの組み合わせはテスト済みで最高の結果をもたらします。推奨事項をクリックして直接適用してください。',
  'admin.ai.active': 'アクティブ',
  'admin.ai.apply': '適用',
  'admin.ai.avoid': '避ける',
  'admin.ai.excellentQuality': '優秀な品質',
  'admin.ai.goodQuality': '良い品質',
  'admin.ai.poorQuality': '希釈された品質 - 非推奨',
  'admin.ai.proTips': 'プロのヒント',
  'admin.ai.tip1Title': '2つのプリセットが最適：',
  'admin.ai.tip1Desc': '希釈されない明確な視点',
  'admin.ai.tip2Title': 'プライマリプリセットが重要：',
  'admin.ai.tip2Desc': '最初のプリセットが最も大きな影響を持ちます',
  'admin.ai.tip3Title': '対極を避ける：',
  'admin.ai.tip3Desc': '「極端」+「創造的」= 矛盾',
  'admin.ai.tip4Title': '最大3つのプリセット：',
  'admin.ai.tip4Desc': '4つ以上のプリセットでは結果が一般的になりすぎます',
  'admin.ai.warningManyPresets': '警告：プリセットが多い',
  'admin.ai.warningManyPresetsDesc': '{{count}}個のプリセットが選択されています。これにより結果が薄まる可能性があります。',
  'admin.ai.warningRecommend': '推奨：最大2-3個のプリセット',
  'admin.ai.forOptimalResults': '最適な結果のために。',
  'admin.ai.presets': 'プリセット',
  'admin.ai.multiSelect': '（複数選択可能）',
  'admin.ai.presetsDesc': '1つ以上のプリセットを選択してください。最初のプリセットが最も高い重み付けを持つプライマリプリセットです。',
  'admin.ai.primaryPreset': 'プライマリプリセット',
  'admin.ai.weightControl': '重み付けコントロール',
  'admin.ai.weightControlDesc': '各プリセットが分析にどの程度強く影響するかを調整します',
  'admin.ai.manual': '手動',
  'admin.ai.automatic': '自動',
  'admin.ai.autoWeightingActive': '自動重み付け有効：',
  'admin.ai.autoWeightingDesc': '重み付けはプリセットの数に基づいて自動的に最適化されます。',
  'admin.ai.primary': 'プライマリ',
  'admin.ai.totalWeight': '合計',
  'admin.ai.shouldBe100': '合計100%にする必要があります',
  'admin.ai.normalize': '正規化',
  'admin.ai.combinedSettings': '結合設定',
  'admin.ai.presetsCount': '個のプリセット',
  'admin.ai.strictness': '厳格さ',
  'admin.ai.realism': '現実性',
  'admin.ai.creativity': '創造性',
  'admin.ai.detailLevel': '詳細レベル',
  'admin.ai.customInstructions': 'カスタム指示',
  'admin.ai.customInstructionsDesc': 'プリセットと組み合わせる追加の指示',
  'admin.ai.customInstructionsPlaceholder': '例：「DACH市場に焦点を当てる」、「常に具体的な数値を使用する」、「既存の競合他社と比較する」、「常に例を挙げて回答する」...',
  'admin.ai.customInstructionsHint': 'これらの指示は選択されたプリセットと自動的に組み合わされます。',
  'admin.ai.manualFinetuning': '手動微調整',
  'admin.ai.manualFinetuningHint': '（任意、プリセット値を上書きします）',
  'admin.ai.manualFinetuningDesc': '何かを微調整したい場合は、結合された値を手動で調整します。',
  'admin.ai.tone': 'トーン',
  'admin.ai.mild': '穏やか',
  'admin.ai.strict': '厳格',
  'admin.ai.creative': '創造的',
  'admin.ai.realistic': '現実的',
  'admin.ai.conservative': '保守的',
  'admin.ai.compact': 'コンパクト',
  'admin.ai.detailed': '詳細',
  'admin.ai.responseLength': '応答の長さ',
  'admin.ai.short': '簡潔',
  'admin.ai.medium': '中程度',
  'admin.ai.long': '詳細',
  'admin.ai.focusAreas': '分析フォーカスエリア',
  'admin.ai.autoRating': '自動評価',
  'admin.ai.autoRatingDesc': 'すべての分析は自動的に評価（良い/普通/悪い）を受けます',
  'admin.ai.showSources': '情報源を表示',
  'admin.ai.showSourcesDesc': '応答内のデータソースと市場データへの参照',
  'admin.ai.hidePreview': 'プレビューを隠す',
  'admin.ai.showPreview': 'プレビューを表示',
  'admin.ai.aiBehavior': 'AIの動作',
  'admin.ai.length': '長さ',
  'admin.ai.liveExample': 'ライブ例',
  'admin.ai.testSettings': '設定をテスト',
  'admin.ai.selectExampleQuestion': '例の質問を選択：',
  'admin.ai.userAsks': 'ユーザーからの質問：',
  'admin.ai.generating': 'AIが応答を生成中...',
  'admin.ai.generateExample': '例の応答を生成',
  'admin.ai.aiResponds': 'AIアシスタントの応答：',
  'admin.ai.generateHint': '「例の応答を生成」をクリックして、AIがあなたの設定でどのように応答するかを確認してください。',
  'admin.ai.reset': 'リセット',
  'admin.ai.saved': '保存しました！',
  'admin.ai.saveSettings': '設定を保存',

  // --- Table headers ---
  'admin.coupons.code': 'コード',
  'admin.coupons.credits': 'クレジット',

  // --- AI Model Descriptions ---
  'admin.ai.model.standardDesc': '高品質でバランスの取れた分析。ほとんどのニッチ評価とアイデア検証に最適な選択肢です。',
  'admin.ai.model.preciseAnalyses': '精密な分析',
  'admin.ai.model.bestBalance': '最高のバランス',
  'admin.ai.model.recommended': '推奨',
  'admin.ai.model.fastDesc': 'ニッチの簡単なチェック、ブレインストーミング、初期評価のための超高速応答。速度が重要な場合に最適です。',
  'admin.ai.model.fast': '高速',
  'admin.ai.model.fastestResponses': '最速応答',
  'admin.ai.model.thinkingDesc': '高度な論理的思考による深い分析。複雑な市場分析、批判的評価、戦略的計画に適しています。',
  'admin.ai.model.deepestAnalysis': '最も深い分析',
  'admin.ai.model.logicalThinking': '論理的思考',
  'admin.ai.model.strategy': '戦略',

  // --- AI Preset Names & Descriptions ---
  'admin.ai.preset.strict.name': '厳格な分析',
  'admin.ai.preset.strict.desc': '批判的、事実に基づく、ごまかしなし。弱点を容赦なく露呈します。',
  'admin.ai.preset.extreme.name': '極端な分析',
  'admin.ai.preset.extreme.desc': '最大の厳格さ、容赦ない批判、最悪のシナリオ重視。厳しい現実チェックのみに。',
  'admin.ai.preset.professional.name': 'プロフェッショナル',
  'admin.ai.preset.professional.desc': '客観的、構造化、バランスが取れている。経験豊富なビジネスコンサルタントのようです。',
  'admin.ai.preset.realistic.name': '現実的',
  'admin.ai.preset.realistic.desc': '正直で実用的。実現可能な実装と実際の市場データに焦点を当てます。',
  'admin.ai.preset.creative.name': '創造的でやる気を高める',
  'admin.ai.preset.creative.desc': '刺激的、アイデア豊富、ポジティブ。機会と型破りな道を見つけます。',
  'admin.ai.preset.balanced.name': 'バランス',
  'admin.ai.preset.balanced.desc': '批判とやる気の良いミックス。デフォルトモード。',
  'admin.ai.preset.investor.name': '投資家の視点',
  'admin.ai.preset.investor.desc': 'ベンチャーキャピタリストのように。スケーリング、ROI、出口戦略に焦点を当てます。',
  'admin.ai.preset.startup-coach.name': 'スタートアップコーチ',
  'admin.ai.preset.startup-coach.desc': '創業者のための実践的なメンター。迅速な実装とMVPに焦点を当てます。',
  'admin.ai.preset.market-researcher.name': '市場調査員',
  'admin.ai.preset.market-researcher.desc': 'データ駆動で分析的。深い市場と競合分析。',
  'admin.ai.preset.risk-analyst.name': 'リスクアナリスト',
  'admin.ai.preset.risk-analyst.desc': 'リスクと最悪のシナリオに焦点を当てる。現実的な計画のため。',

  // --- Focus Areas ---
  'admin.ai.focus.marktanalyse': '市場分析',
  'admin.ai.focus.wettbewerb': '競争',
  'admin.ai.focus.monetarisierung': '収益化',
  'admin.ai.focus.risiken': 'リスク',
  'admin.ai.focus.finanzen': '財務',
  'admin.ai.focus.skalierung': 'スケーリング',
  'admin.ai.focus.innovation': '革新',
  'admin.ai.focus.trends': 'トレンド',
  'admin.ai.focus.differenzierung': '差別化',
  'admin.ai.focus.umsetzung': '実装',
  'admin.ai.focus.zielgruppe': 'ターゲット層',
  'admin.ai.focus.marketing': 'マーケティング',

  // --- Tone Options ---
  'admin.ai.tone.direkt': '直接的で率直',
  'admin.ai.tone.professionell': 'プロフェッショナルで客観的',
  'admin.ai.tone.ehrlich': '正直で実用的',
  'admin.ai.tone.motivierend': 'やる気を高めポジティブ',
  'admin.ai.tone.freundlich': '親しみやすく協力的',
  'admin.ai.tone.akademisch': '学術的で分析的',

  // --- Example Questions ---
  'admin.ai.question.niche': 'どのような収益性の高いニッチをお勧めしますか？',
  'admin.ai.question.evaluate': '私のアイデアを評価してください：犬の飼い主のためのアプリ',
  'admin.ai.question.trends': '現在、どのトレンドに可能性がありますか？',
  'admin.ai.question.sharpen': '私のニッチをどのように磨けばよいですか？',

  'admin.ai.rec.bestCombination.title': '🏆 ベスト組み合わせ（2プリセット）',
  'admin.ai.rec.bestCombination.desc': '批判的だが建設的、具体的な行動ステップ付き',
  'admin.ai.rec.bestCombination.useCase': 'ほとんどの分析に推奨',

  'admin.ai.rec.balancedThree.title': '⚖️ バランス（3プリセット）',
  'admin.ai.rec.balancedThree.desc': 'プロフェッショナル、現実的、投資家向け',
  'admin.ai.rec.balancedThree.useCase': '包括的なビジネス分析に',

  'admin.ai.rec.creativeDriven.title': '💡 創造的でやる気を高める（2プリセット）',
  'admin.ai.rec.creativeDriven.desc': '実用的な実装のヒントで刺激的',
  'admin.ai.rec.creativeDriven.useCase': 'アイデア創出とブレインストーミングに',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'メニューを開く',
  'header.home': 'ホーム',
  'header.notifications': '通知',
  'header.settings': '設定',
  'header.profile': 'プロフィール',
  'sidebar.collapse': 'サイドバーを折りたたむ',
  'sidebar.expand': 'サイドバーを展開',
  'sidebar.close': 'メニューを閉じる',
  'sidebar.plan': 'プラン',
  'sidebar.backToWebsite': 'ウェブサイトに戻る',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': 'おかえりなさい',
  'overview.greetingSub': 'あなたの判定デスクの最新状況です。',
  'overview.heroCta': '新しい判定',
  'overview.currentPlan': '現在のプラン',
  'overview.creditsLabel': 'クレジット',
  'overview.usedThisCycle': '今サイクルの使用',
  'overview.resetsOn': 'リセット日',
  'overview.unlimitedTitle': '無制限',
  'overview.builderPerk': 'Builder フルアクセス — 制限なし。',
  'overview.runOne': '判定を実行',
  'overview.lastVerdicts': '直近 5 件の判定',
  'overview.noActivity': 'まだ判定がありません — 最初の分析を始めましょう',
  'overview.tipTitle': 'ヒント',
  'overview.tipBody': 'アイデアを 2 つの言語で試してみる — 判定が一方で和らぐなら、あなたの仮定はローカルであり、普遍的ではありません。',
  'onboard.skip': "スキップ",
  'onboard.cta.next': "次へ",
  'onboard.cta.start': "始める",
  'onboard.s1.title': "IdeaVerdictへようこそ",
  'onboard.s1.body': "作る前に、あなたのビジネスアイデアにAIが下す判決。",
  'onboard.s2.title': "容赦なく正直な判決",
  'onboard.s2.body': "誇張なし、お世辞なし。本物の市場データ、本物の競合、本物のリスク。",
  'onboard.s3.title': "ビルダーレポートをPDFで",
  'onboard.s3.body': "アーキテクチャ、財務、市場戦略を網羅した25〜75ページのレポートを生成。",
  'onboard.s4.title': "準備はいつでもOK",
  'onboard.s4.body': "登録して、1分以内に最初の判決を受け取れ。",
  'builderReport.title': "ビルダーレポートを生成中",
  'builderReport.subtitle': "包括的な分析 + 開発者向けブリーフィング ― 完了時にPDFとしてダウンロード。",
  'builderReport.idea': "あなたのアイデア",
  'builderReport.ideaPlaceholder': "ビジネスアイデアを記述(空欄なら直前に話したアイデアを使用)…",
  'builderReport.cta': "レポート生成",
  'builderReport.credits': "クレジット",
  'builderReport.deductedNow': "成功時に消費",
  'builderReport.dontClose': "このウィンドウは閉じないこと ― 生成に30〜90秒かかる。",
  'builderReport.done': "PDFダウンロード完了 ― ダウンロードフォルダを確認。",
  'builderReport.failed': "生成に失敗しました",
  'builderReport.close': "閉じる",
  'builderReport.cancel': "キャンセル",
  'builderReport.running': "生成中…",
  'builderReport.retry': "再試行",
  'builderReport.unknownError': "生成に失敗。クレジットは返却されるはず。",
  'builderReport.signInRequired': "レポート生成にはサインインが必要。",
  'builderReport.ideaRequired': "AIが分析できるよう、アイデアを記述すること。",
  'builderReport.fromChat': "現在の会話から",
  'builderReport.noIdeaDetected': "これまで話したアイデアを使用。",
  'builderReport.contextHint': "AIはこのチャットの内容をすべて使う ― 新しいアイデアは作らない。",
  'builderReport.step.core': "コア分析を生成中",
  'builderReport.step.market': "拡張市場分析を追加中",
  'builderReport.step.tech': "技術アーキテクチャを追加中",
  'builderReport.step.financials': "財務モデルを追加中",
  'builderReport.step.compet': "競合インテリジェンスを追加中",
  'builderReport.step.gtm': "市場投入戦略を追加中",
  'builderReport.step.deepdive': "業界深掘り分析を追加中",
  'builderReport.step.pdf': "PDFを編成中…",
  'briefing.title': "開発者ブリーフィングを生成中",
  'briefing.subtitle': "11セクションの技術ブリーフィング ― 完了時にPDFとしてダウンロード。",
  'briefing.ideaPlaceholder': "ビジネスアイデアを記述(空欄なら直前に話したアイデアを使用)…",
  'briefing.cta': "ブリーフィング生成",
  'briefing.step.core': "開発者ブリーフィングを生成中",
  'briefing.step.pdf': "PDFを編成中…",
  'pricing.gold.name': "ゴールド",
  'pricing.gold.description': "クレジット増量 + 50ページレポート",
  'pricing.gold.credits': "月12,500クレジット",
  'pricing.platinum.name': "プラチナ",
  'pricing.platinum.description': "最上位ティア + 75ページレポート",
  'pricing.platinum.credits': "月15,000クレジット",
  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "ja" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "残りクレジットは{{count}}のみ!",
  'trial.upgradeNow': "今すぐアップグレード",
  'trial.upgradeNowArrow': "今すぐアップグレード →",
  'trial.creditsExhausted': "クレジット切れ",
  'trial.upgradeForUnlimited': "アップグレードで無制限利用",
  'trial.noCreditsPlaceholder': "クレジットなし…",
  'hero.badgeHonest': "正直で偏りのないAI",
  'hero.badge60sec': "60秒で判決",
  'hero.badge20Lang': "20以上の言語",
  'hero.widget.label': "アイデアの判決",
  'hero.widget.passed': "合格",
  'hero.widget.demoIdea': "医学生向けAIチューター",
  'hero.widget.market': "市場",
  'hero.widget.demand': "需要",
  'hero.widget.competition': "競合",
  'hero.widget.verdictReady': "判決完了 · 47秒",
  'hero.widget.riskFlagged': "リスク検出",
  'hero.widget.crowdedMarket': "飽和市場 · 既存4社",
  'hero.widget.suggestedPivot': "推奨ピボット",
  'hero.widget.nicheBySpecialty': "専門分野でニッチ化",
  'hero.widget.feasibilityGain': "実現可能性 +38%",
  'hero.widget.analysisDone': "分析完了",
  'hero.widget.metrics56': "6指標中5つ",
  'hero.stats.verdictSpeed': "判決スピード",
  'cta.badge': "60秒で判決",
  'cta.subtitleEnd': "推測抜きで。",
  'cta.signinPrompt': "アカウント既存? サインイン",
  'cta.trustTrial': "7日間無料トライアル",
  'cta.trustNoCard': "カード不要",
  'cta.trustCancel': "いつでも解約",
  'footer.themeLabel': "テーマ:",
  'footer.lightMode': "ライトモード",
  'footer.darkMode': "ダークモード",
  'footer.sectionProduct': "プロダクト",
  'footer.sectionLegal': "法的事項",
  'nav.switchLight': "ライトモードに切替",
  'nav.switchDark': "ダークモードに切替",
  'features.badge': "なぜIdeaVerdictか",
  'features.mainFeatureLabel': "主要機能",
  'chatError.planRestriction': "この機能には上位プランが必要です。",
  'chatError.creditDeduction': "支払い処理に失敗しました。もう一度お試しください。",
  'chatError.aiService': "AI サービスは一時的に利用できません。クレジットは消費されていません。もう一度お試しください。",
  'chatError.parseError': "想定外の応答形式を受信しました。もう一度お試しください。",
  'chatError.sessionExpired': "セッションが期限切れです。再度サインインしてください。",
  'chatError.timeout': "リクエストに時間がかかりすぎました。もう一度お試しください。",
  'chatError.generic': "応答の取得に失敗しました。もう一度お試しください。",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "ja" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "残りクレジットは{{count}}のみ!",
  'trial.outOfCredits': "クレジット切れ",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "飽和市場 · 既存4社",
  'hero.widget.nicheBySpec': "専門分野でニッチ化",
  'hero.widget.feasibilityUp': "実現可能性 +38%",
  'hero.widget.fiveOfSix': "6指標中5つ",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "25ページの Builder Report",
  'pricing.gold.report': "50ページの Builder Report",
  'pricing.platinum.report': "75ページの Builder Report",
  'auth.bestValue': "ベストバリュー",
  'auth.elite': "エリート",
  'builderReport.friendlyError': "今回はレポートを完成できませんでした。クレジットは消費されていません — 少し時間を置いてから再度お試しください。",
  'builderReport.persistHint': "この問題が続く場合は support@ideaverdict.ai までお問い合わせください。",
};
